export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/tuner-icon.svg?38ebbe6eeb2d21b95c1e636954f2e1c9";